import * as React from 'react';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button, Input, FormGroup, FormFeedback } from 'reactstrap';
import { TranslationFunction } from 'i18next';
import { ValidationError } from '../../userApi';

interface Props {
  show: boolean;
  t: TranslationFunction;
  error: string;
  removeUserUpdateVE: (code: ValidationError.CodeEnum) => void;
  close: () => void;
  confirm: (password: string) => void;
}

interface ConfirmModalState {
  password: string;
}

class ConfirmModal extends React.Component<Props, ConfirmModalState> {
  public state = { password: '' };

  public render() {
    const { password } = this.state;
    const { show, t, error, confirm, close, removeUserUpdateVE } = this.props;
    return (
      <Modal
        id="user_update_form_modal"
        isOpen={show}
      >
        <ModalHeader>{t('Please confirm your current password')}</ModalHeader>
        <ModalBody>
          <FormGroup
            id="user_update_form__password"
          >
            <Input
              invalid={Boolean(error)}
              value={password}
              type={'password'}
              onChange={(e) => this.setState({ password: e.target.value })}
              onBlur={() => removeUserUpdateVE(ValidationError.CodeEnum.ErrPasswordIncorrect)}
              autoComplete={'off'}
            />
            {error && <FormFeedback>{error}</FormFeedback>}
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button
            id="user_update_form__confirm"
            color="primary"
            disabled={password.length <= 2}
            onClick={() => confirm(password)}
          >{t('Confirm')}</Button>
          <Button outline={true} color="danger" onClick={close}>{t('Cancel')}</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default (ConfirmModal);
